import axios from "axios";
import API from "../../common/API";
import { API_URL } from "../../config/config";

/*** 
@purpose : Get management body list
@Parameter : {}
**/
export const fetchManagementBodyList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL + API.GET_MANAGEMENTBODY_TYPE_LIST + `?timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          mode: "no-cors",
          timestamp: timestamp,
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get suburb list
@Parameter : {data}
**/
export const fetchSuburbList = async (data) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.GET_SUBURB_LIST +
        `?stateID=${data.stateId}&cityID=${data.cityId}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          mode: "no-cors",
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get street list
@Parameter : {data}
**/
export const fetchStreetList = async (data) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.GET_STREET_LIST +
        `?stateID=${data.stateId}&cityID=${data.cityId}&suburbID=${data.suburbId}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          mode: "no-cors",
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get speciality list
@Parameter : {}
**/
export const fetchSpecialityList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL + API.GET_MEDICAL_SPECIALITY_LIST + `?timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          mode: "no-cors",
          timestamp: timestamp,
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get department list
@Parameter : {data}
**/
export const fetchDepartmentList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(API_URL + API.GET_AFFILIATED_DEPARTMEMT + `?timestamp=${timestamp}`, {
      headers: {
        "x-api-key": token,
        "Access-Control-Allow-Origin": "*",
        mode: "no-cors",
        timestamp: timestamp,
      },
    })
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get role list
@Parameter : {data}
**/
export const fetchRoleList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(API_URL + API.GET_ROLE_LIST + `?timestamp=${timestamp}`, {
      headers: {
        "x-api-key": token,
        "Access-Control-Allow-Origin": "*",
        mode: "no-cors",
        timestamp: timestamp,
      },
    })
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Add organization customer
@Parameter : {body}
**/
export const addOrganizationCustomer = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.ADD_ORGANIZATION_CUSTOMER, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Add person customer
@Parameter : {body}
**/
export const addPersonCustomer = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.ADD_PERSON_CUSTOMER, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Get customer code
@Parameter : {body}
**/
export const getCustomerCode = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return fetch(API_URL + API.GET_CUSTOMER_CODE, {
    method: "post",
    headers: {
      "x-api-key": token,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};
